// loads the chatbot widget into the bottom corner of the page

// destructure our passed vars
const {
	lang_code
} = chatbot;

window.__raChatbot = window.__raChatbot || {};

// get our id
window.__raChatbot.id = "65468f4e-531e-4f6f-a7da-87f7bba0e726";
// which is diff for spanish pages
if ('es' === lang_code) {
	window.__raChatbot.id = "cc717dc9-96b0-4297-9cb0-9609ac5135ca";
}

(function () {
	const chatbot_el = document.createElement('script');
	chatbot_el.type = 'text/javascript';
	chatbot_el.async = true;
	chatbot_el.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'eu.fw-cdn.com/11496414/427794.js';
	chatbot_el.setAttribute('chat', 'true');
	chatbot_el.setAttribute('widgetId', window.__raChatbot.id);
	const s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(chatbot_el, s);
})();
